const homeMessagePath = 'home.';
const homeTransMsgPath = 'home.components.';
const homeButtonMsgPath = 'button.';

const translations = {
    TITLE: homeMessagePath + 'pageTitle',

    JOIN_AI_CAPTION: homeTransMsgPath + "joinAICaption",
    TRADITIONAL_SCANS: homeTransMsgPath + "joinAIDescription",
    JOIN_AI_FOOTER_DESCRIPTION: homeTransMsgPath + "joinAIFooter",

    LAUNCH_TOOL_LABEL: homeButtonMsgPath + "launchTool",
    LEARN_MORE_LABEL: homeButtonMsgPath + "learnMore",

    BANNER_TITLE: homeMessagePath + 'bannerTitle',
    BANNER_SUB_TITLE: homeMessagePath + 'bannerSubTitle',
    BANNER_DESC: homeMessagePath + 'bannerDescription',
}

export default translations